/* eslint-disable no-prototype-builtins */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import React, {
    useState, useEffect, useCallback, useContext,
} from 'react';
import { motion } from 'framer-motion';
import { CDN } from '../../constants';
import { distributorService } from '../../service/distributor.service';
import { userService } from '../../service/user.service';
import Pagination from '../../Components/Pagination';
import HeaderContext from '../../Components/Context/HeaderContext';
import AreaListSkeleton from '../MISReports/AreaWiseCustomerReport/AreaListSkeleton';
import EmptyScreen from '../../Components/GlobalEmplyPage';

function StockListing() {
    const [threeplDropdown, setthreeplDropdown] = useState(false);
    const [categoryDropdown, setcategoryDropdown] = useState(false);
    const [exportDropdown, setExportDropdown] = useState(false);
    const [threePL, setthreePL] = useState([]);
    const [category, setCategory] = useState([]);
    const [products, setProducts] = useState([]);
    const [filter, setFilter] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [filterQuery, setFilterQuery] = useState({ page: 1, limit: 8 });
    const [totalPage, setTotalPage] = useState('');
    const [alldata, setalldata] = useState({});
    const [loading, setLoading] = useState(true);
    const [emptyData, setEmptyData] = useState(false);

    const {
        SetSuccessMessage,
    } = useContext(HeaderContext);

    const getThreepl = async () => {
        const thpl = await userService.getthreepl();
        if (thpl.data.data.length > 0) {
            setthreePL(thpl.data.data);
        }
        const categoryList = await distributorService.getOffersMainCategory();
        if (categoryList.data.data.length > 0) {
            setCategory(categoryList.data.data);
        }
    };
    const handleImage = (img) => (img ? `${CDN}/product-images/${img}` : '/images/gen.png');

    const handleFetch = useCallback((query) => {
        distributorService.StockList(query).then((res) => {
            if (res.data.data.success_status) {
                if (res.data.data.hasOwnProperty('url')) {
                    SetSuccessMessage('Export successful');
                    delete filterQuery.export;
                    window.open(res.data.data.url, '_blank');
                    setTimeout(() => {
                        SetSuccessMessage('');
                    }, 2000);
                } else if (res.data.data.data.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                    setProducts(res.data.data.data);
                } else {
                    setProducts(res.data.data.data);
                    setalldata(res.data.data.data);
                    setCurrentPage(res.data.data.current_page);
                    setTotalPage(res.data.data.number_of_pages);
                    setLoading(false);
                }
            }
        });
    }, []);

    const handleFilter = (value, key) => {
        filter[key] = value;
        setFilter(filter);
        if (['category', 'search', 'page', 'export'].includes(key)) {
            filterQuery[key] = value;
        } else {
            filterQuery[key] = value.ORGANIZATION_ID;
        }
        setFilterQuery(filterQuery);
        handleFetch(filterQuery);
    };

    const handlePageClick = async (data) => {
        const page = data.selected + 1;
        setCurrentPage(page);
        handleFilter(page, 'page');
    };

    useEffect(() => {
        getThreepl();
        handleFetch(filterQuery);
    }, []);

    const handleClear = async () => {
        setFilterQuery({ page: 1, limit: 8 });
        setFilter({ page: 1, limit: 8 });
        handleFetch({ page: 1, limit: 8 });
    };

    return (
        <div className="py-6 main-screen">
            <div className="flex justify-between items-center pb-[18px]">
                <h5 className="text-xs4 font-normal text-[#555259]">Stock</h5>
                <div className="flex items-center justify-between">
                    <div className="mr-[6px]">
                        <div className="dropdown w-[174px] relative">
                            <button
                                type="button"
                                id="spacial12"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                className="dropdown-to w-full h-[35px] px-3 text-start shadow  rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-f2 font-normal text-[#A5A5A5] "
                                onClick={() => setthreeplDropdown(!threeplDropdown)}
                            >
                                {filter.threepl !== undefined ? <p className="font-normal text-[#090406]">{filter.threepl.DESCRIPTION}</p> : 'Select 3PL location'}
                                <img src="/images/sorticon-product-list.svg" alt="icon" className="absolute top-[15px] right-[12px]" />
                            </button>
                            <ul className={`dropdown-menu product-price ${threeplDropdown ? 'show' : 'hidden'} w-full absolute bg-[#FFFFFF]  rounded-lg  border border-t-0 shadow-s15  z-[40]`} aria-labelledby="special12">
                                {threePL && threePL.map((item, index) => (
                                    <li className="pl-3.5 w-full pt-2 bg-[#ffffff]" key={`threepl-${index}`}>
                                        <a className="dropdown-item text-sm37 font-normal text-[#090406] w-full inline-block territory-inp" href="#" onClick={() => { handleFilter(item, 'threepl'); setthreeplDropdown(false); }}>{item.DESCRIPTION}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="mr-[6px]">
                        <div className="dropdown w-[174px] relative">
                            <button
                                type="button"
                                id="spacial1"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                className="dropdown-to h-[35px] w-full px-3 text-start shadow  rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-f2 font-normal text-[#A5A5A5] "
                                onClick={() => setcategoryDropdown(!categoryDropdown)}
                            >
                                {filter.category !== undefined ? <p className="font-normal text-[#090406]">{filter.category}</p> : 'Select Category'}
                                <img src="/images/sorticon-product-list.svg" alt="icon" className="absolute top-[15px] right-[12px]" />
                            </button>
                            <ul className={`dropdown-menu product-price  w-full ${categoryDropdown ? 'show' : 'hidden'} absolute bg-[#FFFFFF]  rounded-lg  border border-t-0 shadow-s15  z-[40]`} aria-labelledby="special1">
                                {category && category.map((item, index) => (
                                    <li className="pl-3.5 w-full pt-2 bg-[#ffffff]" key={`category-${index}`}>
                                        <a className="dropdown-item text-sm37 font-normal text-[#090406] w-full inline-block territory-inp" href="#" onClick={() => { handleFilter(item, 'category'); setcategoryDropdown(false); }}>{item}</a>
                                    </li>
                                ))}

                            </ul>
                        </div>
                    </div>
                    <div className="relative mr-2">
                        <label htmlFor="search" />
                        <input type="text" name="search" id="search" className="w-[235px] h-[35px] bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]" placeholder="Search" onInput={(e) => handleFilter(e.target.value, 'search')} />
                        <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer" />
                    </div>
                    <div className="mr-2 dropdown relative">
                        <button onClick={() => handleClear()} type="button" id="exportDropdown" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[107px] border border-[#555259] rounded-lg">
                            Clear Filter
                        </button>
                    </div>
                    <div className="mr-2 dropdown relative">
                        <button type="button" id="exportDropdown" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-toggle h-[35px] text-xs2 font-semibold text-[#555259] w-[107px] border border-[#555259] rounded-lg" onClick={() => setExportDropdown(!exportDropdown)}>
                            Export
                        </button>
                        <ul className={`dropdown-menu sm:min-w-[110px] min-w-[120px] absolute ${exportDropdown === true ? '' : 'hidden'} bg-[#FFFFFF] rounded-lg shadow-s2 z-[40] sm:p-3.5 p-1.5`} aria-labelledby="exportDropdown">
                            <li className=" sm:py-1 py-0.5 export border-b border-[#D8D8D8]">
                                <a className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" href="#" onClick={() => { handleFilter('csv', 'export'); setExportDropdown(false); }}>CSV</a>
                            </li>
                            <li className=" sm:py-1 py-0.5 border-b border-[#D8D8D8]">
                                <a className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" href="#" onClick={() => { handleFilter('pdf', 'export'); setExportDropdown(false); }}>PDF</a>
                            </li>
                            <li className=" sm:py-1 py-0.5">
                                <a className="dropdown-item sm:text-xs5 text-sm font-normal text-[#555259] w-full inline-block px-1.5 py-0.5 text-center" href="#" onClick={() => { handleFilter('excel', 'export'); setExportDropdown(false); }}>Excel</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {loading ? <AreaListSkeleton />
                : (
                    <div>
                        {products.length > 0 && (
                            <div className="overflow-auto dropdown-menu pb-7 relative z-10" style={{ height: 'calc(100vh - 298px)' }}>
                                <table className="w-full table-auto relative">
                                    <thead className="sticky top-0 left-0 z-[2]">
                                        <tr className="bg-[#555259] h-10">
                                            <th className="py-[5px] px-6 rounded-bl-lg rounded-tl-lg min-w-[171px]  bg-[#555259]" scope="col">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Product Image
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[150px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    3PL
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[160px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Product Code
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[280px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Product Name
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[400px] ">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Product Description
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Size
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[188px] text-center">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Stock
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[170px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    UoM
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    MOQ
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[200px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Standard Pack Size
                                                </span>
                                            </th>
                                            <th scope="col" className="py-[5px] px-7 min-w-[180px] rounded-tr-lg rounded-br-lg">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    AWS Classification
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {products.length > 0 && products.map((prod, prodId) => (
                                            <tr className="bg-[#FDFDFE] border-b border-[#DFEAF7]" key={`prod-${prodId}`}>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7  text-center">
                                                    <motion.img
                                                        initial={{ opacity: 0, scale: 0.6 }}
                                                        animate={{ opacity: 1, scale: 1 }}
                                                        transition={{
                                                            duration: 0.8,
                                                            delay: 0.5,
                                                            ease: [0, 0.71, 0.2, 1.01],
                                                        }}
                                                        src={handleImage(prod?.IMAGE_NAME)}
                                                        alt="icon"
                                                        className="w-full"
                                                    />
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {prod.PLANT_NAME}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {prod.CONCATENATED_SEGMENTS}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-[5px] px-7 text-center">
                                                    {prod.MODEL_DESCRIPTION || '-'}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] my-[9px] px-7 more-lines_stock">
                                                    {prod.DESCRIPTION}
                                                </td>
                                                <td className="text-sm font-normal text-center text-[#090406]  py-[5px] px-7">
                                                    {`${prod.DIAMETER !== null ? `${prod.DIAMETER}mm` : ''}`}
                                                    {`${prod.LENGTH !== null && prod.DIAMETER ? 'x' : ''}`}
                                                    {`${prod.LENGTH !== null ? `${prod.LENGTH}mm` : ''}`}
                                                    {prod.LENGTH === null && prod.DIAMETER === null ? '-' : ''}
                                                </td>
                                                <td className="text-sm font-normal text-center text-[#090406]  py-[5px] px-7">
                                                    {prod.STOCK_ONHAND_QTY}
                                                </td>
                                                <td className="text-sm font-normal text-center text-[#090406] py-[5px] px-7">
                                                    {prod.PRIMARY_UOM_CODE}
                                                </td>
                                                <td className="text-sm font-normal text-center text-[#090406] py-[5px] px-7">
                                                    {prod.MINIMUM_ORDER_QUANTITY || 1}
                                                </td>
                                                <td className="text-sm font-normal text-center text-[#090406] py-[5px] px-7">
                                                    {prod.PACKING_SIZE || 1}
                                                    {' '}
                                                    {prod.PRIMARY_UOM_CODE}
                                                </td>
                                                <td className="text-sm font-normal text-center text-[#090406] py-[5px] px-7">
                                                    {prod.AWS_CLASSIFICATION || '-'}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {products && products.length > 0 && (
                            <Pagination
                                handlePageClick={handlePageClick}
                                totalPage={totalPage}
                                List={alldata}
                                currentPage={currentPage}
                            />
                        )}
                        {emptyData && (
                            <EmptyScreen
                                search="yes"
                                text="no Stock"
                                buttonRequired={false}
                                all={filterQuery.search !== '' ? ' under searched term' : ' found'}
                            />
                        )}

                    </div>
                )}
        </div>
    );
}

export default StockListing;
